// 9fbef606107a605d69c0edbcd8029e5d
import Styled, { css } from 'styled-components';
import { getIconPath } from '@tcp/core/src/utils';
import colors from '../../../../../../styles/themes/TCP/colors';

export default css`
  &.filter-chips-main {
    .chips-container {
      display: flex;
      flex-direction: column;
      padding-top: 10px;
      border-bottom: 1px solid rgba(146, 146, 146, 0.4);
    }
    .applied-chips {
      flex: 1;
      display: flex;
      flex-direction: row;
      margin: 12px 9px 12px 0;
      flex-wrap: wrap;
    }
    .applied-chip-label {
      margin: 8px 9px 8px 0;
      border: 0.5px solid #9b9b9b;
      border-radius: 3px;
      padding: 6px 5px;
      font-size: ${(props) => props.theme.typography.fontSizes.fs14};
      text-transform: capitalize;
    }
    .price-label {
      text-transform: lowercase;
    }
    .applied-chip-label:first-letter {
      text-transform: uppercase;
    }
    .applied-chip-label.size-fit-filter {
      text-transform: uppercase;
    }
    .chip-clicks {
      min-height: 0;
      width: 21px;
      background-color: #fff;
    }
    .chip-image {
      background: url('${(props) => getIconPath('search-close-icon', props)}');
      background-size: 100% 100%;
      height: 10px;
      width: 10px;
    }
    .filters-label-container {
      display: flex;
    }
    .filters-applied-label {
      flex: 1;
      font-size: ${(props) => props.theme.typography.fontSizes.fs16};
      font-family: 'Nunito';
      font-weight: bold;
      display: flex;
      flex-wrap: wrap;
      letter-spacing: 0.45px;
      color: ${colors.PRIMARY.DARK};
    }
    .clear-all {
      flex: 1;
      text-align: right;
    }
    .clear-all-button {
      padding: 0;
      background-color: #fff;
      border: 0;
      min-height: 0;
      text-transform: capitalize;
      color: ${colors.BUTTON.BLUE.LEFT_FILTERS_BTN};
      text-decoration: underline;
      font-size: 14px;
      font-weight: 700;
      font-family: 'Nunito';
    }
  }
`;

export const ChipsBorder = Styled.div`
    ${(props) =>
      !props.categoryPlp && props.viewPort
        ? `
        border-top: 1px solid rgba(146, 146, 146, 0.4);
    `
        : ''}
`;
